<template>
  <transition name="fade">
    <div v-show="isRouteLoading" class="loading-animation-container" :class="{ 'is-authenticated': auth.isAuthenticated }">
      <svg id="mainSVG" xmlns="http://www.w3.org/2000/svg" viewBox="250 180 300 240">
        <g id="whole" fill="#9B111E" stroke="#9B111E" stroke-width="2" style="filter: drop-shadow(0px 2px 6px rgba(155, 17, 30, 0.3));">
          <circle id="leader" cx="328" cy="300" r="15"/>
          <circle class="follower" cx="364" cy="300" r="15"/>
          <circle class="follower" cx="400" cy="300" r="15"/>
          <circle class="follower" cx="436" cy="300" r="15"/>
          <circle class="follower" cx="472" cy="300" r="15"/>
        </g>
      </svg>
    </div>
  </transition>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useAuthStore } from '../stores/auth'

const props = defineProps({
  isRouteLoading: Boolean
})

const auth = useAuthStore()

onMounted(() => {
  // Inicializa animação
  if (window.gsap) {
    initAnimation()
  } else {
    // Carrega o GSAP caso não esteja no bundle
    const script = document.createElement('script')
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js'
    script.onload = () => initAnimation()
    document.head.appendChild(script)
  }
})

function initAnimation() {
  const gsap = window.gsap
  
  let blendEases = (startEase, endEase, blender) => {
    var s = gsap.parseEase(startEase),
        e = gsap.parseEase(endEase),
        blenderFn = gsap.parseEase(blender || "power3.inOut");
    return function(v) {
      var b = blenderFn(v);
      return s(v) * (1 - b) + e(v) * b;
    };
  }

  gsap.set('#mainSVG', {
    visibility: 'visible'
  })

  let tl = gsap.timeline({
    repeat: -1
  });
  
  tl.to('#leader', {
    duration: 4,
    x: 36 * 3,
    ease: blendEases('circ.in', 'expo')
  })
  .to('.follower', {
    duration: 2,
    svgOrigin: gsap.utils.wrap(['328 300', '364 300', '400 300', '436 300', '472 300']),
    rotation: -180,
    stagger: {
      amount: 2
    },
    ease: blendEases('circ.in', 'expo')
  }, 0)
  .to('#whole', {
    x: 36,
    duration: 5,
    ease: 'linear',
  }, 0)
  .to('.follower', {
    duration: 1.5,
    stagger: {
      amount: 1,
      repeat: 1,
      yoyo: true
    },
    ease: blendEases('power3.in', 'expo'),
    fillOpacity: 0
  }, 0)

  tl.timeScale(3)
}
</script>

<style scoped>
.loading-animation-container {
  bottom: -12px; /* Alinhado exatamente na altura da barra de 38px do rodapé */
  right: -20px;
  width: 160px;  /* BEM MAIOR no PC */
  height: 120px;
  position: fixed;
  z-index: 297;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* não bloquear cliques */
}

/* Alinhamento refinado para monitores Ultra Wide */
@media (min-width: 2000px) {
  .loading-animation-container {
    right: calc((100vw - 1800px) / 2 + 10px);
  }
}

@media (max-width: 1080.98px) {
  .loading-animation-container {
    bottom: 20px; /* EXATAMENTE colado no topo do app-menu de 70px (Deslogado) */
    right: -15px;
    width: 140px; /* Tamanho confortável no mobile */
    height: 120px;
  }
  
  .loading-animation-container.is-authenticated {
    bottom: 65px; /* Altura ajustada quando o submenu de usuário está visível (Logado) */
  }
}

#mainSVG {
  width: 100%;
  height: 100%;
  visibility: hidden;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(125px) scale(0.95);
}
</style>
